import React from "react";
import { connect } from "react-redux";
import moment from "moment-timezone";

declare var itemUrl: string;
declare var tagUrl: string;

class LogTable extends React.Component<any, any> {
  renderLog = (log: any) => {
    const { timezone } = this.props;
    const created = moment(log.created_at).tz(timezone);
    return (
      <tr className="text-center" key={log.created_at}>
        <td className="double-lines-content heighter">
          {created.format("MM/DD/YYYY")}
          <br />
          {created.format("hh:mm:ss A")}
        </td>
        <td>
          <a href={itemUrl.replace(":id", log.item_number)} target="_blank">
            {log.item_number}
          </a>
        </td>
        <td>
          <a href={tagUrl.replace(":id", log.epc_tag_id)} target="_blank">
            {log.serial_number}
          </a>
        </td>
        <td className="text-left">{log.item_name}</td>
        <td>{log.zone}</td>
        <td>{log.reader}</td>
      </tr>
    );
  };

  render() {
    const { logs = [] } = this.props;

    return (
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <table className="sn-table table table-hover table-striped table-responsive dataTable">
            <thead>
              <tr>
                <th className="text-center">DateTime</th>
                <th className="text-center">Item#</th>
                <th className="text-center">Serial#</th>
                <th className="text-left" style={{ width: "40%" }}>
                  Item Details
                </th>
                <th className="text-center">Zone</th>
                <th className="text-center">Reader</th>
              </tr>
            </thead>
            <tbody>{logs.map(this.renderLog)}</tbody>
          </table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  logs: state.live.logs,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LogTable);
